import type { SplitOrderInvoicesDataItem } from '../split_order_invoices_list_types';

const GOLANG_ZERO_DATE = '0001-01-01T00:00:00Z';

function isZeroDate(val: any): boolean {
    return !val || val === GOLANG_ZERO_DATE || val === '0001-01-01T00:00:00';
}

export default function splitOrderInvoicesListApiToVM(apiResult: any): SplitOrderInvoicesDataItem[] {
    const items: SplitOrderInvoicesDataItem[] = Array.isArray(apiResult) ? apiResult : [];
    items.forEach(item => {
        if (isZeroDate(item.DateCreated)) item.DateCreated = null;
        if (isZeroDate(item.VendorInvoiceDate)) item.VendorInvoiceDate = null;
        if (isZeroDate(item.InvoiceReconciledDate)) item.InvoiceReconciledDate = null;
    });
    return items;
}
